import axios from "axios";
import { useCallback } from "react";
import { selectorFamily, useRecoilValue } from "recoil";
import { COMMUNICATE_ERROR_MESSAGE_TOPICS, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD } from "../constants/ErrorMessage";

const apiUrl = process.env.REACT_APP_SEASON_DATA_URL;
const topicsURL = `${apiUrl}/season/index.json`;
const topics2URL = `${apiUrl}/season2/index.json`;
const topics3URL = `${apiUrl}/season3/index.json`;

const _listTopics = async (url) => {
	const config = {
		method: 'GET',
		url: url,
		params: {
			't': Date.now(),
		},
		errorHandle: {
			message: COMMUNICATE_ERROR_MESSAGE_TOPICS,
			additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD,
			exclusionStatus: [403, 404]
		}
	};
	
	return await axios(config)
		.then(response => {
			return response.data;
		})
		.catch(e => {
		});
};

const topicsState = selectorFamily({
	key: 'topicsState',
	get: url => () => {
		return new Promise(resolve => requestIdleCallback(async () => {
			const data = await _listTopics(url);
			resolve(data);
		}))
	},
});

export const useTopics = (season) => {
	let url;
	switch(season) {
		case 'season1':
			url = topicsURL;
			break;
		case 'season2':
			url = topics2URL;
			break;
		case 'season3':
			url = topics3URL;
			break;
		default:
			break;
	}
	const topics = useRecoilValue(topicsState(url));

	const fixURL = useCallback(path => {
		if (path) {
			return new URL(path, new URL(url, window.location));
		} else {
			return path;
		}
	}, [url]);

	return {
		topics,
		fixURL,
	};
};
